'use strict';
const angular = require('angular');

export class imageEditorScaleComponent {

  constructor(StorageService) {
    'ngInject';

    this.StorageService = StorageService;
  }

  $onInit = function () {
    this.config = this.resolve.config;

    this.imageId = this.config.storageId;

    this.StorageService.getImageMeta({id: this.imageId}, meta => {
      this.meta = meta;
      this.ratio = meta.width / meta.height;
      this.factor = 1;
    });
  };

  ok() {
    this.close({$value: this.factor});
  }

  cancel() {
    this.dismiss({$value: 'cancel'});
  }
}

export default angular.module('conduApp.imageEditorScale', [])
  .component('imageEditorScale', {
    template: require('./image-editor-scale.component.html'),
    bindings: {
      resolve: '<',
      config: '<',
      close: '&',
      dismiss: '&'
    },
    controller: imageEditorScaleComponent
  })
  .name;



// WEBPACK FOOTER //
// ./client/components/image-editor-scale/image-editor-scale.component.js